import { currencyGet, type ApiEnvelope } from '@/lib/task-api';

/**
 * Faz sureleri — SUNUCUDAN.
 *
 * Neden metne gomulmuyor: sureler yapilandirilabilir (DOVIZHUB_TASK_PHASE_*) ve uc ayri
 * yerde ayni sabitten turetiliyor. "2 dakika" diye yazilmis bir yardim metni, degeri
 * degistiren ilk deploy'da YALAN olur -- ve bu metin tam da kullanicinin kurallari
 * ogrenmek icin okudugu yer.
 */
export type PhaseDurations = {
  offerSeconds: number;
  decideSeconds: number;
  paymentSeconds: number;
  graceSeconds: number;
  /**
   * Tamamlanan isleme itiraz (uyari) suresi — `completed` yazildigi andan itibaren
   * (2026-09-23, karar Q1). Musteri kartindaki "Uyari Gonder" dugmesi buna gore acilir.
   */
  disputeSeconds: number;
};

/** Uc erisilemezse istemci KENDI varsayilanlariyla devam eder; bkz. lib/task-phase.ts. */
export const FALLBACK_PHASES: PhaseDurations = {
  offerSeconds: 120,
  decideSeconds: 240,
  paymentSeconds: 900,
  graceSeconds: 600,
  disputeSeconds: 86400,
};

export const fetchPhaseDurations = async (): Promise<PhaseDurations> => {
  const { data } = await currencyGet<ApiEnvelope & { phases?: Partial<PhaseDurations> }>(
    '/v1/config',
    {},
  );
  return { ...FALLBACK_PHASES, ...(data.phases ?? {}) };
};
